import React from "react";

export default function SocialLinks({linkedInProfileUrl, twitterProfileUrl, websiteUrl , className}) {
  return (
    <div className={
      className ||
      "d-flex justify-content-center align-items-center gap-3"
    }>
      {linkedInProfileUrl ? (
        <div>
          <a href={linkedInProfileUrl} target="_blank" rel="noreferrer">
            <img
              width="25"
              height="25"
              src="/Illustrations/linkedin 2.svg"
              alt=""
            />
          </a>
        </div>
      ) : null}

      {twitterProfileUrl ? (
        <div>
          <a href={twitterProfileUrl} target="_blank" rel="noreferrer">
            <img
              width="25"
              height="25"
              src="/Illustrations/twitter 1.svg"
              alt=""
            />
          </a>
        </div>
      ) : null}

      {websiteUrl ? (
        <div>
          <a href={websiteUrl} target="_blank" rel="noreferrer">
            <img width="25" height="25" src="/Illustrations/link.svg" alt="" />
          </a>
        </div>
      ) : null}
    </div>
  );
}
